// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_8f2c1a6","panelWrapper":"_709c798"};